import React from 'react';
import styles from './EnableCompanyAlisaField.module.scss';
import { Checkbox, Form } from 'antd';
import { fieldNames } from '../../../common/config';

const enableAlisaFieldName = fieldNames.enableAlisa;
const enableCompanyAlisaName = fieldNames.isIVRForServiceCompany;
const FormItem = Form.Item;

const EnableCompanyAlisaField = ({ form }) => {
  const enableAlisaFieldValue = form.getFieldValue(enableAlisaFieldName);

  return (
    <FormItem style={{ margin: 0 }}>
      {form.getFieldDecorator(enableCompanyAlisaName, {
        valuePropName: 'checked',
        getValueFromEvent: (e) => (e.target.checked ? 1 : 0),
        initialValue: 0,
      })(
        <Checkbox
          disabled={!enableAlisaFieldValue}
          className={styles.custonCheckbox}
        >
          По всей УК
        </Checkbox>
      )}
    </FormItem>
  );
};

export default EnableCompanyAlisaField;
